import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a7495318295d50014ad7f1d_1786456733613_c5dae0ab/buchhaltungaktas/src/app/not-found.tsx");
